export const REPORT_CATEGORIES = [
  { value: "operations", text: "Sales & operations" },
  { value: "customers", text: "Customers" },
  { value: "financial", text: "Financial" },
  { value: "inventory", text: "Inventory" },
  { value: "gra", text: "GRA tax" },
  { value: "fiscal", text: "Fiscal (Z/X)" },
  { value: "audit", text: "Audit" },
];

export const REPORT_CATALOG = [
  { key: "daily", category: "operations", label: "Daily sales", endpoint: "reports/daily", itemsKey: "productPerformance", dateFilter: "daily", exportKey: null },
  { key: "sales-trend", category: "operations", label: "Sales trend", endpoint: "reports/sales-trend", itemsKey: "points", dateFilter: "none", exportKey: null },
  { key: "sales-by-user", category: "operations", label: "Sales by user", endpoint: "reports/sales-by-user", itemsKey: null, exportKey: null },
  { key: "product-performance", category: "operations", label: "Product performance", endpoint: "reports/product-performance", itemsKey: null, exportKey: null },
  { key: "revenue-by-category", category: "operations", label: "Revenue by category", endpoint: "reports/revenue-by-category", itemsKey: null, exportKey: null },
  { key: "sales-by-hour", category: "operations", label: "Sales by hour", endpoint: "reports/sales-by-hour", itemsKey: "hours", exportKey: "sales-by-hour" },
  { key: "sales-by-payment", category: "operations", label: "Sales by payment method", endpoint: "reports/sales-by-payment", itemsKey: "methods", exportKey: "sales-by-payment" },
  { key: "voided-sales", category: "operations", label: "Voided sales", endpoint: "reports/voided-sales", itemsKey: "sales", exportKey: "voided-sales" },
  { key: "discounts", category: "operations", label: "Discount report", endpoint: "reports/discounts", itemsKey: "sales", exportKey: "discounts" },
  { key: "returns-refunds", category: "operations", label: "Returns & refunds", endpoint: "reports/returns-refunds", itemsKey: "lines", exportKey: "returns-refunds" },
  { key: "cash-reconciliation", category: "operations", label: "Cash reconciliation", endpoint: "reports/cash-reconciliation", itemsKey: "reconciliations", exportKey: "cash-reconciliation" },
  { key: "cash-drawer", category: "operations", label: "Cash drawer", endpoint: "reports/cash-drawer", itemsKey: "drawers", exportKey: "cash-drawer" },
  { key: "opening-closing-cash", category: "operations", label: "Opening vs closing cash", endpoint: "reports/opening-closing-cash", itemsKey: "shifts", exportKey: "opening-closing-cash" },
  { key: "sales-by-customer", category: "customers", label: "Sales by customer", endpoint: "reports/sales-by-customer", itemsKey: "customers", exportKey: "sales-by-customer" },
  { key: "top-customers", category: "customers", label: "Top customers", endpoint: "reports/top-customers", itemsKey: "customers", exportKey: "top-customers", extra: "topN" },
  { key: "loyalty-points", category: "customers", label: "Loyalty points", endpoint: "reports/loyalty-points", itemsKey: "customers", exportKey: "loyalty-points" },
  { key: "customer-purchase-history", category: "customers", label: "Customer purchase history", endpoint: "reports/customer-purchase-history", itemsKey: "sales", exportKey: null, extra: "customerId" },
  { key: "profit-margin", category: "financial", label: "Profit margin by product", endpoint: "reports/profit-margin", itemsKey: "products", exportKey: "profit-margin" },
  { key: "cogs", category: "financial", label: "COGS", endpoint: "reports/cogs", itemsKey: "lines", exportKey: "cogs" },
  { key: "profit-summary", category: "financial", label: "Profit summary", endpoint: "reports/profit-summary", itemsKey: "periods", exportKey: "profit-summary", extra: "periodType" },
  { key: "sales-vs-cost", category: "financial", label: "Sales vs cost", endpoint: "reports/sales-vs-cost", itemsKey: "periods", exportKey: "sales-vs-cost" },
  { key: "income-vs-expense", category: "financial", label: "Income vs expense", endpoint: "reports/income-vs-expense", itemsKey: "periods", exportKey: "income-vs-expense" },
  { key: "expenses", category: "financial", label: "Expense report", endpoint: "reports/expenses", itemsKey: "lines", exportKey: "expenses" },
  { key: "stock-levels", category: "inventory", label: "Stock levels", endpoint: "reports/stock-levels", itemsKey: null, dateFilter: "none", exportKey: null },
  { key: "inventory-valuation", category: "inventory", label: "Inventory valuation", endpoint: "reports/inventory-valuation", itemsKey: "items", dateFilter: "none", exportKey: "inventory-valuation" },
  { key: "low-stock", category: "inventory", label: "Low stock", endpoint: "reports/low-stock", itemsKey: "items", dateFilter: "none", exportKey: "low-stock" },
  { key: "out-of-stock", category: "inventory", label: "Out of stock", endpoint: "reports/out-of-stock", itemsKey: "items", dateFilter: "none", exportKey: "out-of-stock" },
  { key: "stock-adjustments", category: "inventory", label: "Stock adjustments", endpoint: "reports/stock-adjustments", itemsKey: "adjustments", exportKey: "stock-adjustments" },
  { key: "stock-movement", category: "inventory", label: "Stock movement", endpoint: "reports/stock-movement", itemsKey: "movements", exportKey: "stock-movement" },
  { key: "inventory-aging", category: "inventory", label: "Inventory aging", endpoint: "reports/inventory-aging", itemsKey: "items", dateFilter: "none", exportKey: "inventory-aging" },
  { key: "slow-movers", category: "inventory", label: "Slow moving products", endpoint: "reports/slow-movers", itemsKey: "products", exportKey: "slow-movers" },
  { key: "stock-transfers", category: "inventory", label: "Stock transfers", endpoint: "reports/stock-transfers", itemsKey: "transfers", exportKey: "stock-transfers" },
  { key: "damaged-expired", category: "inventory", label: "Damaged / expired stock", endpoint: "reports/damaged-expired", itemsKey: "items", exportKey: "damaged-expired" },
  { key: "price-changes", category: "inventory", label: "Price change history", endpoint: "reports/price-changes", itemsKey: "changes", exportKey: "price-changes", extra: "priceType" },
  { key: "vat", category: "gra", label: "VAT", endpoint: "reports/vat", itemsKey: "summaries", exportKey: "vat" },
  { key: "nhil-getfund", category: "gra", label: "NHIL & GETFund", endpoint: "reports/nhil-getfund", itemsKey: "summaries", exportKey: "nhil-getfund" },
  { key: "tax-payable", category: "gra", label: "Tax payable", endpoint: "reports/tax-payable", itemsKey: "lines", exportKey: "tax-payable" },
  { key: "tax-receivable", category: "gra", label: "Tax receivable", endpoint: "reports/tax-receivable", itemsKey: "lines", exportKey: "tax-receivable" },
  { key: "tax-payments", category: "gra", label: "Tax payments", endpoint: "reports/tax-payments", itemsKey: "lines", exportKey: "tax-payments" },
  { key: "tax-return", category: "gra", label: "Tax return summary", endpoint: "reports/tax-return", itemsKey: null, exportKey: null },
  { key: "tax-compliance", category: "gra", label: "Tax compliance", endpoint: "reports/tax-compliance", itemsKey: null, exportKey: null },
  { key: "tax-by-period", category: "gra", label: "Tax by period", endpoint: "reports/tax-collected-by-period", itemsKey: "summaries", exportKey: null, extra: "taxPeriodType" },
  { key: "tax-by-product", category: "gra", label: "Tax by product", endpoint: "reports/tax-summary-by-product", itemsKey: "summaries", exportKey: null },
  { key: "zero-rated", category: "gra", label: "Zero-rated / exempt", endpoint: "reports/zero-rated-exempt", itemsKey: "summaries", exportKey: null },
  { key: "transaction-log", category: "audit", label: "Transaction log", endpoint: "reports/transaction-log", itemsKey: "entries", exportKey: "transaction-log" },
  { key: "receipt-listing", category: "audit", label: "Receipt listing", endpoint: "reports/receipt-listing", itemsKey: "receipts", exportKey: "receipt-listing" },
  { key: "audit-trail", category: "audit", label: "Audit trail", endpoint: "reports/audit-trail", itemsKey: "entries", exportKey: null },
  { key: "x-reading", category: "fiscal", label: "X reading (interim)", endpoint: "reports/x-reading", itemsKey: null, dateFilter: "none", exportKey: null },
  { key: "fiscal-history", category: "fiscal", label: "Fiscal reading history", endpoint: "reports/fiscal-readings", itemsKey: "readings", dateFilter: "none", exportKey: null },
];

export const REPORT_FIELDS = {
  points: [
    { key: "label", label: "Period" },
    { key: "salesCount", label: "Sales" },
    { key: "totalAmount", label: "Total", format: "money" },
  ],
  "sales-by-user": [
    { key: "userName", label: "Cashier" },
    { key: "storeName", label: "Store" },
    { key: "salesCount", label: "Sales" },
    { key: "totalAmount", label: "Total", format: "money" },
  ],
  "product-performance": [
    { key: "productSku", label: "SKU" },
    { key: "productName", label: "Product" },
    { key: "quantitySold", label: "Qty" },
    { key: "totalRevenue", label: "Revenue", format: "money" },
    { key: "averagePrice", label: "Avg price", format: "money" },
  ],
  "revenue-by-category": [
    { key: "category", label: "Category" },
    { key: "quantitySold", label: "Qty" },
    { key: "productCount", label: "Products" },
    { key: "totalRevenue", label: "Revenue", format: "money" },
  ],
  "stock-levels": [
    { key: "productSku", label: "SKU" },
    { key: "productName", label: "Product" },
    { key: "storeName", label: "Store" },
    { key: "quantity", label: "Qty" },
    { key: "available", label: "Available" },
    { key: "isLowStock", label: "Low stock" },
  ],
  productPerformance: [
    { key: "productSku", label: "SKU" },
    { key: "productName", label: "Product" },
    { key: "quantitySold", label: "Qty" },
    { key: "totalAmount", label: "Revenue", format: "money" },
  ],
  hours: [
    { key: "hourLabel", label: "Hour" },
    { key: "transactionCount", label: "Transactions" },
    { key: "totalSales", label: "Total sales", format: "money" },
    { key: "averageTransaction", label: "Avg", format: "money" },
  ],
  methods: [
    { key: "paymentMethod", label: "Method" },
    { key: "transactionCount", label: "Txns" },
    { key: "totalAmount", label: "Total", format: "money" },
    { key: "percentOfTotal", label: "%" },
  ],
  sales: [
    { key: "saleNumber", label: "Sale #" },
    { key: "status", label: "Status" },
    { key: "storeName", label: "Store" },
    { key: "total", label: "Total", format: "money" },
  ],
  reconciliations: [
    { key: "closedAt", label: "Closed", format: "datetime" },
    { key: "storeName", label: "Store" },
    { key: "expectedCash", label: "Expected", format: "money" },
    { key: "countedCash", label: "Counted", format: "money" },
    { key: "variance", label: "Variance", format: "money" },
    { key: "varianceType", label: "Type" },
  ],
  drawers: [
    { key: "storeName", label: "Store" },
    { key: "userName", label: "Cashier" },
    { key: "status", label: "Status" },
    { key: "openingFloat", label: "Opening", format: "money" },
    { key: "totalCashSales", label: "Cash sales", format: "money" },
    { key: "variance", label: "Variance", format: "money" },
  ],
  shifts: [
    { key: "shiftDate", label: "Date" },
    { key: "storeName", label: "Store" },
    { key: "openingFloat", label: "Opening", format: "money" },
    { key: "closingCash", label: "Closing", format: "money" },
    { key: "netChange", label: "Net", format: "money" },
  ],
  customers: [
    { key: "rank", label: "#" },
    { key: "customerName", label: "Customer" },
    { key: "transactionCount", label: "Txns" },
    { key: "totalAmount", label: "Total", format: "money" },
    { key: "currentBalance", label: "Points" },
    { key: "pointsEarned", label: "Earned" },
  ],
  products: [
    { key: "productSku", label: "SKU" },
    { key: "productName", label: "Product" },
    { key: "quantitySold", label: "Qty sold" },
    { key: "totalRevenue", label: "Revenue", format: "money" },
    { key: "grossProfit", label: "Profit", format: "money" },
    { key: "profitMarginPercent", label: "Margin %" },
    { key: "daysSinceLastSale", label: "Days idle" },
    { key: "stockQuantity", label: "Stock" },
  ],
  periods: [
    { key: "periodLabel", label: "Period" },
    { key: "transactionCount", label: "Txns" },
    { key: "totalRevenue", label: "Revenue", format: "money" },
    { key: "totalCogs", label: "COGS", format: "money" },
    { key: "grossProfit", label: "Profit", format: "money" },
    { key: "income", label: "Income", format: "money" },
    { key: "expenses", label: "Expenses", format: "money" },
    { key: "netProfit", label: "Net", format: "money" },
    { key: "date", label: "Date" },
    { key: "totalSales", label: "Sales", format: "money" },
    { key: "marginPercent", label: "Margin %" },
  ],
  items: [
    { key: "productSku", label: "SKU" },
    { key: "productName", label: "Product" },
    { key: "storeName", label: "Store" },
    { key: "quantity", label: "Qty" },
    { key: "available", label: "Available" },
    { key: "inventoryValue", label: "Value", format: "money" },
    { key: "retailValue", label: "Retail", format: "money" },
    { key: "daysSinceLastSale", label: "Days" },
    { key: "ageBucket", label: "Age bucket" },
  ],
  adjustments: [
    { key: "date", label: "Date" },
    { key: "productSku", label: "SKU" },
    { key: "quantityChange", label: "Change" },
    { key: "valueImpact", label: "Value", format: "money" },
    { key: "reason", label: "Reason" },
    { key: "userName", label: "User" },
  ],
  movements: [
    { key: "occurredAt", label: "When", format: "datetime" },
    { key: "type", label: "Type" },
    { key: "productSku", label: "SKU" },
    { key: "quantity", label: "Qty" },
    { key: "reference", label: "Reference" },
  ],
  changes: [
    { key: "changedAt", label: "When", format: "datetime" },
    { key: "productSku", label: "SKU" },
    { key: "priceType", label: "Type" },
    { key: "oldPrice", label: "Old", format: "money" },
    { key: "newPrice", label: "New", format: "money" },
    { key: "percentChange", label: "%" },
  ],
  summaries: [
    { key: "date", label: "Date" },
    { key: "periodLabel", label: "Period" },
    { key: "storeName", label: "Store" },
    { key: "totalSales", label: "Sales", format: "money" },
    { key: "totalTax", label: "Tax", format: "money" },
    { key: "totalVat", label: "VAT", format: "money" },
    { key: "productName", label: "Product" },
    { key: "zeroRatedSales", label: "Zero-rated", format: "money" },
  ],
  entries: [
    { key: "occurredAt", label: "When", format: "datetime" },
    { key: "createdAt", label: "When", format: "datetime" },
    { key: "type", label: "Type" },
    { key: "action", label: "Action" },
    { key: "reference", label: "Reference" },
    { key: "amount", label: "Amount", format: "money" },
    { key: "userName", label: "User" },
  ],
  receipts: [
    { key: "completedAt", label: "Date", format: "datetime" },
    { key: "receiptNumber", label: "Receipt #" },
    { key: "saleNumber", label: "Sale #" },
    { key: "total", label: "Total", format: "money" },
  ],
  transfers: [
    { key: "transferNumber", label: "Transfer #" },
    { key: "status", label: "Status" },
    { key: "fromStore", label: "From" },
    { key: "toStore", label: "To" },
    { key: "itemCount", label: "Items" },
    { key: "totalQuantity", label: "Qty" },
    { key: "createdAt", label: "Created", format: "datetime" },
  ],
  lines: [
    { key: "date", label: "Date" },
    { key: "storeName", label: "Store" },
    { key: "accountName", label: "Account" },
    { key: "vatPayable", label: "VAT", format: "money" },
    { key: "inputTax", label: "Input tax", format: "money" },
    { key: "amount", label: "Amount", format: "money" },
    { key: "type", label: "Type" },
    { key: "productSku", label: "SKU" },
    { key: "quantityLost", label: "Qty lost" },
    { key: "valueLost", label: "Value", format: "money" },
  ],
  readings: [
    { key: "readingType", label: "Type" },
    { key: "readingNumber", label: "#" },
    { key: "storeName", label: "Store" },
    { key: "userName", label: "User" },
    { key: "createdAt", label: "When", format: "datetime" },
  ],
};
